import type { Movie } from "@/mocks/movies";

export interface FilterState {
  types: string[];
  genres: string[];
  regions: string[];
  years: number[];
  keyword: string;
}

export type SortKey = "updated" | "hot" | "rating";

export const emptyFilters: FilterState = {
  types: [],
  genres: [],
  regions: [],
  years: [],
  keyword: "",
};

export function filterMovies(list: Movie[], filters: FilterState): Movie[] {
  const kw = filters.keyword.trim().toLowerCase();
  return list.filter((movie) => {
    if (filters.types.length && !filters.types.includes(movie.type)) return false;
    if (filters.genres.length && !filters.genres.some((g) => movie.genres.includes(g))) return false;
    if (filters.regions.length && !filters.regions.includes(movie.region)) return false;
    if (filters.years.length && !filters.years.includes(movie.year)) return false;
    if (kw && !movie.title.toLowerCase().includes(kw)) return false;
    return true;
  });
}

export function sortMovies(list: Movie[], key: SortKey): Movie[] {
  const copy = [...list];
  if (key === "updated") copy.sort((a, b) => b.updated.localeCompare(a.updated));
  else if (key === "hot") copy.sort((a, b) => b.hot - a.hot);
  else copy.sort((a, b) => b.rating - a.rating);
  return copy;
}

export function toggleInArray<T>(arr: T[], value: T): T[] {
  return arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value];
}